export function register() {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', async () => {
    const swUrl = (process.env.PUBLIC_URL || '') + '/service-worker.js';

    try {
      const response = await fetch(swUrl, { method: 'HEAD' }).catch(() => null);
      if (response) {
        const contentType = response.headers.get('content-type');
        if (response.status === 404 || (contentType && contentType.includes('text/html'))) {
          return;
        }
      }

      const registration = await navigator.serviceWorker.register(swUrl);
      console.log('[ServiceWorker] Registrado com sucesso:', registration);
    } catch (error) {
      if (error && error.message && error.message.includes('MIME type')) {
        return;
      }
      console.error('[ServiceWorker] Erro durante o registro:', error);
    }
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error('[ServiceWorker] Erro durante o desregistro:', error);
      });
  }
}
